import React from "react";
import { helpers } from "services";
import get from "lodash/get";
import { Typography } from "antd";

const TableSimpleRow = ({ storage, index, currency, onStorageClick = () => {} }) => {
    const raw_material = get(storage, "Сыря.price", get(storage, "Сыря", 0));
    const semi_finished_product = get(storage, "Полуфабрикат.price", get(storage, "Полуфабрикат", 0));
    const realization = get(storage, "Реализация.price", get(storage, "Реализация", 0));

    const totalSum = +raw_material + +semi_finished_product + +realization;

    return (
        <tr>
            <td className="w-7 text-cen">{index + 1}</td>
            <td>
                <Typography.Link onClick={onStorageClick} className="text-link-style fw-600 cursor-pointer">
                    {get(storage, "name")}
                </Typography.Link>
            </td>
            <td className={`text-right ${raw_material ? "fw-500" : "fo-5"}`}>
                {helpers.convertToReadable(raw_material)} {currency}
            </td>
            <td className={`text-right ${semi_finished_product ? "fw-500" : "fo-5"}`}>
                {helpers.convertToReadable(semi_finished_product)} {currency}
            </td>
            <td className={`text-right ${realization ? "fw-500" : "fo-5"}`}>
                {helpers.convertToReadable(realization)} {currency}
            </td>
            <td className="text-right bg-main">
                <div className={`${totalSum ? "fw-500" : "fo-5"}`}>
                    {helpers.convertToReadable(totalSum)} {currency}
                </div>
            </td>
        </tr>
    );
};

export default TableSimpleRow;
